"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const frontend_library_darkhorse_1 = require("@usafacts/frontend-library-darkhorse");
const react_dom_1 = __importDefault(require("react-dom"));
const react_1 = __importDefault(require("react"));
class MosaicPlot {
  constructor(container) {
    this.container = container;
  }
  async draw(promises, options) {
    react_dom_1.default.render(react_1.default.createElement(frontend_library_darkhorse_1.SOTU2021Education, options), this.container.node());
  }
  static drawCanvas() {
    /* no canvas here */
  }
}
exports.default = MosaicPlot;